import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { React, useEffect, useState } from "react";
import { DateUtil } from "../../fxms/datas/DateUtil";
NoDataToDisplay(Highcharts);

/**
 * @description 설비진단 > 설비성능분석 차트
 * @author SONJIEUN
 * @date 01/08/2025
 * @param {*}
 * @return  설비진단 > 설비성능분석 차트
 */
const UI_3_4_Chart = (props) => {
const facType = props.facType;
const data = props.data;

function getData(data){
    let result = []
    for (let res of data) {
        if (res.effEquipVal !== undefined && res.regDtm !== undefined) {
            result.push([DateUtil.makeDate(res.regDtm).getTime(), res.effEquipVal]);
        }
      }

    return result;
}

const options = {
  
    chart: {
        zooming: {
            type: 'x'
        },
        backgroundColor : "transparent",
    },

    exporting: {
        buttons: {
            contextButton: {
                enabled: false
            }
        }
    },
    title: {
        text: null,
    },
    credits: {
        enabled: false
    },
    legend: {
        enabled: false,
    }, 
    tooltip: {
        pointFormat: facType!== '스팀'? '총효율: {point.y}%' : '운전효율: {point.y}%',
        valueDecimals: 2
    },

    xAxis: {
        type: 'datetime',
        labels : {
            style: {
                fontSize: '11px',
                color: 'rgba(255,255,255,.8)'
            }
        },
    },
    yAxis: {
        title :{
            enabled: false
        },
        gridLineColor: 'rgba(255, 255, 255, 0.2)',
        labels : {
            style: {
                fontSize: '11px',
                color: 'rgba(255,255,255,.8)'
            }
        },
    },

    series: [{
        data: getData(data),
        lineWidth: 0.5,
        label : {
            enabled: false
        }
    }]} 

  return (
    <>
    <figure className="highcharts-figure">     
       <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />   
     </figure>
    </>
  );
};

export default UI_3_4_Chart;
